var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 rounded bg-white w-full"},_vm._l((_vm.pixelCodes),function(ref){
var x = ref.x;
var y = ref.y;
var color = ref.color;
return _c('pre',{key:("pxcode" + x + "," + y)},[_vm._v(_vm._s(("(" + x + ", " + y + ") " + color)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }